import * as tslib_1 from "tslib";
import { OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Questions, StudyState, AreaFocus } from '../../models';
import { ServiceInterface } from 'services/service.interface';
import { Location } from '@angular/common';
import { stateConstant } from '../../../constants';
var PworkflowComponent = /** @class */ (function () {
    function PworkflowComponent(router, _services, _location, _route) {
        this.router = router;
        this._services = _services;
        this._location = _location;
        this._route = _route;
        this.model = new Questions();
        this.states = stateConstant;
        this.campaignName = "";
    }
    PworkflowComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var date, _a, currentUrl, splitUrl, checkUrl, urlData, calc, college, collegeId, student, studentUuid, searchinfo_1, sitem, thisState, studentinfo, statelist_1, index, sitem, thisState, _b, sid, checkResult, redirectUrl, splitData, trackUrl, bucket, state, splitBucket_1, splitState, stateData_1, userinfo, _c, stateList_1, _loop_1, this_1, j, index_1, splitData, sourceUrl, mediumUrl, splitSource, splitMedium, trackData;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        date = new Date();
                        this.year = date.getFullYear();
                        _a = this;
                        return [4 /*yield*/, this._services.getList('/levels')];
                    case 1:
                        _a.levels = _d.sent();
                        currentUrl = window.location.href;
                        splitUrl = currentUrl.split("/");
                        checkUrl = splitUrl[3].split("?");
                        if (!(checkUrl[0] == "calcmatch")) return [3 /*break*/, 10];
                        urlData = currentUrl && currentUrl.split("&");
                        calc = urlData[0] && urlData[0].split("=");
                        if (calc.length == 1) {
                            this.index = 1;
                            this._location.go("/");
                            return [2 /*return*/, false];
                        }
                        this.model.calmatchSrc = calc[1];
                        college = urlData[1] && urlData[1].split("=");
                        collegeId = college[1];
                        this.model.passedIn_college_id = collegeId;
                        student = urlData[2] && urlData[2].split("=");
                        if (!student) return [3 /*break*/, 7];
                        studentUuid = student[1];
                        searchinfo_1 = "";
                        return [4 /*yield*/, this._services.get('/search/searchinfo/' + studentUuid)];
                    case 2:
                        searchinfo_1 = _d.sent();
                        if (!(searchinfo_1 == null)) return [3 /*break*/, 4];
                        this.model.searchdata = "insert";
                        return [4 /*yield*/, this._services.get('/student/' + studentUuid)];
                    case 3:
                        searchinfo_1 = _d.sent();
                        //console.log("Data:",searchinfo);
                        // Set education Data
                        this.model.first_name = searchinfo_1["firstName"];
                        this.model.last_name = searchinfo_1["lastName"];
                        // Set personal Data
                        /*if(searchinfo["levelId"] == 0){
                          this.model.education_goal = "";
                        }else{*/
                        this.model.education_goal = searchinfo_1["levelId"];
                        //}
                        if (searchinfo_1["bucketId"] == 0) {
                            this.model.bucket_id = "";
                        }
                        else {
                            this.model.bucket_id = searchinfo_1["bucketId"];
                        }
                        if (searchinfo_1["state"].toLowerCase() && searchinfo_1["state"].toLowerCase() != "online") {
                            this.model.study_state = new Array();
                            sitem = new StudyState();
                            thisState = this.states.find(function (x) { return x.value.toLowerCase() == searchinfo_1["state"].toLowerCase(); });
                            sitem.name = thisState.name;
                            sitem.value = searchinfo_1["state"];
                            this.model.study_state.push(sitem);
                        }
                        // Set Military Data
                        this.model.military_branch = searchinfo_1["militaryBranch"];
                        this.model.military_status = searchinfo_1["militaryStatus"];
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this._services.get('/student/' + studentUuid)];
                    case 5:
                        studentinfo = _d.sent();
                        this.model.searchdata = "update";
                        this.model.first_name = studentinfo["firstName"];
                        this.model.last_name = studentinfo["lastName"];
                        // Set education Data
                        if (searchinfo_1[0]["bucket_id"] == 0) {
                            this.model.bucket_id = "";
                        }
                        else {
                            this.model.bucket_id = searchinfo_1[0]["bucket_id"];
                        }
                        //this.model.area_focus= new Array<AreaFocus>();
                        this.model.education_goal = searchinfo_1[0]["education_goal"];
                        this.model.online = searchinfo_1[0]["study_type"];
                        /*if(searchinfo[0]["area_focus"] != "" && searchinfo[0]["area_focus"] != null){
                          this.model.area_focus_ids = searchinfo[0]["area_focus"];
                          let majorData = await this._services.getList('/search/majorlist/'+searchinfo[0]["area_focus"]);
                          for (var index = 0; index < majorData.length; index++) {
                            csitem = new AreaFocus();
                            csitem.name = majorData[index].title;
                            csitem.id = majorData[index].id;
                            this.model.area_focus.push(csitem);
                          }
                        }*/
                        // Set personal Data
                        this.model.study_state = new Array();
                        this.model.military_support = searchinfo_1[0]["military_support"];
                        statelist_1 = searchinfo_1[0]["study_state"].split(",");
                        for (index = 0; index < statelist_1.length; index++) {
                            sitem = new StudyState();
                            thisState = this.states.find(function (x) { return x.value.toLowerCase() == statelist_1[index].toLowerCase(); });
                            sitem.name = thisState.name;
                            sitem.value = statelist_1[index];
                            this.model.study_state.push(sitem);
                        }
                        // Set Military Data
                        this.model.military_branch = studentinfo["militaryBranch"];
                        ;
                        this.model.military_status = studentinfo["militaryStatus"];
                        _d.label = 6;
                    case 6:
                        this.model.uuid = studentUuid;
                        this.index = 1;
                        localStorage.setItem("NewUserRegister", 'false');
                        _d.label = 7;
                    case 7:
                        if (!(Number(collegeId) && !student)) return [3 /*break*/, 9];
                        this._location.go("/calcmatch");
                        _b = this;
                        return [4 /*yield*/, this._services.getList("/college/" + collegeId)];
                    case 8:
                        _b.collegeDetails = _d.sent();
                        this.index = 1;
                        _d.label = 9;
                    case 9: return [3 /*break*/, 15];
                    case 10:
                        if (!(checkUrl[0] == "match-schools")) return [3 /*break*/, 14];
                        this._location.go("/");
                        sid = this._route.snapshot.queryParams.sid;
                        if (!sid) return [3 /*break*/, 13];
                        return [4 /*yield*/, this._services.get("/veterans/exist/" + sid)];
                    case 11:
                        checkResult = _d.sent();
                        if (!(checkResult == "success")) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.loginAction(sid)];
                    case 12:
                        _d.sent();
                        _d.label = 13;
                    case 13:
                        this.index = 1;
                        return [3 /*break*/, 15];
                    case 14:
                        if (checkUrl[0] != "") {
                            this.campaignName = checkUrl[0];
                            redirectUrl = "?q=" + checkUrl[0];
                            this._location.go("/" + redirectUrl);
                        }
                        else {
                            this.index = 1;
                            this.checkUrlParam();
                        }
                        _d.label = 15;
                    case 15:
                        if (!(checkUrl[1] && (checkUrl[1].startsWith("q=app-wgt") || checkUrl[1].startsWith("q=cr-wgt") || checkUrl[1].startsWith("q=mbi-wgt") || checkUrl[1].startsWith("q=mmb-wgt") || checkUrl[1].startsWith("q=amforce-widget")))) return [3 /*break*/, 16];
                        splitData = checkUrl[1] && checkUrl[1].split('&');
                        trackUrl = splitData[0];
                        bucket = splitData[1];
                        state = splitData[2];
                        splitBucket_1 = bucket && bucket.split('=');
                        splitState = state && state.split('=');
                        if (bucket && splitBucket_1[0] == 'goal') {
                            this.levels.filter(function (data) {
                                var a = _this.model.education_goal;
                                if (data.levelId == parseInt(splitBucket_1[1])) {
                                    _this.model.education_goal = splitBucket_1[1];
                                }
                            });
                        }
                        if (state && splitState[0] == 'state' && splitState[1]) {
                            stateData_1 = [];
                            stateData_1 = splitState[1] && splitState[1].split(',');
                            this.states.filter(function (data) {
                                stateData_1.filter(function (stateData) {
                                    if (data.value == stateData) {
                                        var stateItem = new StudyState();
                                        if (_this.model.study_state.findIndex(function (x) { return x.value.toLowerCase() == data.value.toLowerCase(); }) < 0) {
                                            stateItem.name = data.name;
                                            stateItem.value = data.value;
                                            _this.model.study_state.push(stateItem);
                                        }
                                        _this.model.study_state_values = _this.model.study_state.map(function (a) { return a.value; }).join(',');
                                    }
                                });
                            });
                        }
                        if (this.levels.filter(function (data) { return data.levelId == parseInt(_this.model.education_goal); }).length > 0 && this.model.study_state.length > 0) {
                            this.index = 2;
                        }
                        else {
                            this.index = 1;
                        }
                        window.history.replaceState({}, document.title, "/?" + trackUrl);
                        return [3 /*break*/, 24];
                    case 16:
                        if (!(checkUrl[0] == "scholarships")) return [3 /*break*/, 20];
                        userinfo = checkUrl[1] && checkUrl[1].split("=");
                        if (!userinfo) return [3 /*break*/, 18];
                        _c = this;
                        return [4 /*yield*/, this._services.get("/scholarship/userinfo/" + userinfo[1])];
                    case 17:
                        _c.scholarshipData = _d.sent();
                        if (this.scholarshipData == "nodata") {
                            this.index = 1;
                            this._location.go("/");
                        }
                        else {
                            this._location.go("/scholarships");
                            this.model.first_name = this.scholarshipData[0].first_name;
                            this.model.last_name = this.scholarshipData[0].last_name;
                            this.model.uuid = userinfo[1];
                            this.model.secondary_bucket_ids = this.scholarshipData[0].area_of_focus;
                            this.model.study_state_values = this.scholarshipData[0].study_states;
                            if (this.scholarshipData[0].study_states.indexOf(",") > -1) {
                                stateList_1 = this.scholarshipData[0].study_states.split(",");
                                _loop_1 = function (j) {
                                    var index_2 = this_1.states.findIndex(function (x) { return x.value == stateList_1[j]; });
                                    this_1.model.study_state.push({ 'name': this_1.states[index_2].name, 'value': this_1.states[index_2].value });
                                };
                                this_1 = this;
                                for (j = 0; j < stateList_1.length; j++) {
                                    _loop_1(j);
                                }
                            }
                            else {
                                index_1 = this.states.findIndex(function (x) { return x.value == _this.scholarshipData[0].study_states; });
                                this.model.study_state.push({ 'name': this.states[index_1].name, 'value': this.states[index_1].value });
                            }
                            //this.model.study_state = [{'name':'Alabama','value':'AL'}];
                            if (this.scholarshipData[0].degree_level == "academic_level_undergraduate") {
                                this.model.education_goal = "5";
                            }
                            else if (this.scholarshipData[0].degree_level == "academic_level_post_graduate") {
                                this.model.education_goal = "7,17";
                            }
                            else if (this.scholarshipData[0].degree_level == "academic_level_certificate") {
                                this.model.education_goal = "18";
                            }
                            else if (this.scholarshipData[0].degree_level == "academic_level_trade_vocational") {
                                this.model.education_goal = "3,18";
                            }
                            else {
                                this.model.education_goal = "0";
                            }
                            this.model.military_branch = '0';
                            this.model.military_status = '0';
                            this.model.checkCollegeInfo = "";
                            this.model.primary_source = 'scholarshipfinder';
                            this.model.bucket_id = this.scholarshipData[0].area_of_study;
                            this.index = 6;
                        }
                        return [3 /*break*/, 19];
                    case 18:
                        this.index = 1;
                        this._location.go("/");
                        _d.label = 19;
                    case 19: return [3 /*break*/, 24];
                    case 20:
                        if (!(checkUrl[0] == "activity")) return [3 /*break*/, 23];
                        splitData = checkUrl[1] && checkUrl[1].split('&');
                        sourceUrl = splitData[0];
                        mediumUrl = splitData[1];
                        splitSource = sourceUrl && sourceUrl.split('=');
                        splitMedium = mediumUrl && mediumUrl.split('=');
                        if (!(splitSource[1] && splitMedium[1])) return [3 /*break*/, 22];
                        trackData = {
                            source: splitSource[1],
                            medium: splitMedium[1]
                        };
                        return [4 /*yield*/, this._services.post('/program/activity/tracking', trackData)];
                    case 21:
                        _d.sent();
                        this.index = 1;
                        _d.label = 22;
                    case 22: return [3 /*break*/, 24];
                    case 23:
                        this.index = 1;
                        this.checkUrlParam();
                        _d.label = 24;
                    case 24: return [2 /*return*/];
                }
            });
        });
    };
    PworkflowComponent.prototype.checkUrlParam = function () {
        var currentUrl = window.location.href;
        var checkUrl = currentUrl.split("?");
        if (checkUrl[1] && checkUrl[1] != "") {
            var campaignUrl = checkUrl[1].split("=");
            this.campaignName = campaignUrl[1];
        }
    };
    PworkflowComponent.prototype.ngOnChanges = function () {
    };
    PworkflowComponent.prototype.loginAction = function (uuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchinfo, csitem, primaryBucket, primaryBucketData_1, _loop_2, this_2, j, index_3, secBuck, secData_1, _loop_3, this_3, j, index_4, sitem, thisState, studentinfo, primaryBucket, primaryBucketData_2, _loop_4, this_4, j, index_5, secBuck, secData_2, _loop_5, this_5, j, index_6, statelist_2, index, sitem, thisState;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchinfo = "";
                        csitem = new AreaFocus();
                        return [4 /*yield*/, this._services.get('/search/searchinfo/' + uuid)];
                    case 1:
                        searchinfo = _a.sent();
                        if (!(searchinfo == null)) return [3 /*break*/, 8];
                        this.model.searchdata = "insert";
                        return [4 /*yield*/, this._services.get('/student/' + uuid)];
                    case 2:
                        searchinfo = _a.sent();
                        //console.log("Data:",searchinfo);
                        // Set education Data
                        csitem = new AreaFocus();
                        this.model.first_name = searchinfo["firstName"];
                        this.model.last_name = searchinfo["lastName"];
                        // Set personal Data
                        /*if(searchinfo["levelId"] == 0){
                          this.model.education_goal = "";
                        }else{*/
                        this.model.education_goal = searchinfo["levelId"];
                        if (!(searchinfo["bucketId"] == 0 || !searchinfo["bucketId"])) return [3 /*break*/, 3];
                        this.model.bucket_id = "";
                        return [3 /*break*/, 5];
                    case 3:
                        this.model.bucket_id = searchinfo["bucketId"];
                        return [4 /*yield*/, this._services.get('/bucketlist')];
                    case 4:
                        primaryBucket = _a.sent();
                        if (searchinfo["bucketId"].indexOf(",") > -1) {
                            primaryBucketData_1 = searchinfo["bucketId"].split(",");
                            _loop_2 = function (j) {
                                var index_7 = primaryBucket.findIndex(function (x) { return x.bucketId == primaryBucketData_1[j]; });
                                this_2.model.primary_bucket.push({ "id": primaryBucket[index_7].bucketId, "name": primaryBucket[index_7].bucketTitle });
                            };
                            this_2 = this;
                            for (j = 0; j < primaryBucketData_1.length; j++) {
                                _loop_2(j);
                            }
                        }
                        else {
                            index_3 = primaryBucket.findIndex(function (x) { return x.bucketId == searchinfo["bucketId"]; });
                            this.model.primary_bucket.push({ "id": primaryBucket[index_3].bucketId, "name": primaryBucket[index_3].bucketTitle });
                        }
                        _a.label = 5;
                    case 5:
                        if (!(searchinfo["secBucketId"] && searchinfo["secBucketId"] != "")) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._services.get('/secondarybucketlist/' + this.model.bucket_id)];
                    case 6:
                        secBuck = _a.sent();
                        if (searchinfo["secBucketId"].indexOf(",") > -1) {
                            secData_1 = searchinfo["secBucketId"].split(",");
                            _loop_3 = function (j) {
                                var index_8 = secBuck.findIndex(function (x) { return x.secBucketId == secData_1[j]; });
                                this_3.model.secondary_bucket.push({ "id": secBuck[index_8].secBucketId, "name": secBuck[index_8].secBucketTitle });
                            };
                            this_3 = this;
                            for (j = 0; j < secData_1.length; j++) {
                                _loop_3(j);
                            }
                        }
                        else {
                            index_4 = secBuck.findIndex(function (x) { return x.secBucketId == searchinfo["secBucketId"]; });
                            this.model.secondary_bucket.push({ "id": secBuck[index_4].secBucketId, "name": secBuck[index_4].secBucketTitle });
                        }
                        _a.label = 7;
                    case 7:
                        //if(searchinfo["state"].toLowerCase() && searchinfo["state"].toLowerCase() != "online"){
                        if (searchinfo["state"]) {
                            this.model.study_state = new Array();
                            sitem = new StudyState();
                            thisState = this.states.find(function (x) { return x.value.toLowerCase() == searchinfo["state"].toLowerCase(); });
                            sitem.name = thisState.name;
                            sitem.value = searchinfo["state"];
                            this.model.study_state.push(sitem);
                        }
                        // Set Military Data
                        this.model.military_branch = searchinfo["militaryBranch"];
                        if (searchinfo["militaryStatus"] == "Retiree") {
                            this.model.military_status = "Retired";
                        }
                        else {
                            this.model.military_status = searchinfo["militaryStatus"];
                        }
                        return [3 /*break*/, 15];
                    case 8: return [4 /*yield*/, this._services.get('/student/' + uuid)];
                    case 9:
                        studentinfo = _a.sent();
                        this.model.searchdata = "update";
                        this.model.first_name = studentinfo["firstName"];
                        this.model.last_name = studentinfo["lastName"];
                        if (!(searchinfo[0]["bucket_id"] == 0)) return [3 /*break*/, 10];
                        this.model.bucket_id = "";
                        return [3 /*break*/, 12];
                    case 10:
                        this.model.bucket_id = searchinfo[0]["bucket_id"];
                        return [4 /*yield*/, this._services.get('/bucketlist')];
                    case 11:
                        primaryBucket = _a.sent();
                        if (searchinfo[0]["bucket_id"].indexOf(",") > -1) {
                            primaryBucketData_2 = searchinfo[0]["bucket_id"].split(",");
                            _loop_4 = function (j) {
                                var index_9 = primaryBucket.findIndex(function (x) { return x.bucketId == primaryBucketData_2[j]; });
                                this_4.model.primary_bucket.push({ "id": primaryBucket[index_9].bucketId, "name": primaryBucket[index_9].bucketTitle });
                            };
                            this_4 = this;
                            for (j = 0; j < primaryBucketData_2.length; j++) {
                                _loop_4(j);
                            }
                        }
                        else {
                            index_5 = primaryBucket.findIndex(function (x) { return x.bucketId == searchinfo[0]["bucket_id"]; });
                            this.model.primary_bucket.push({ "id": primaryBucket[index_5].bucketId, "name": primaryBucket[index_5].bucketTitle });
                        }
                        _a.label = 12;
                    case 12:
                        //this.model.area_focus= new Array<AreaFocus>();
                        this.model.education_goal = searchinfo[0]["education_goal"];
                        this.model.online = searchinfo[0]["study_type"];
                        csitem = new AreaFocus();
                        if (!(searchinfo[0]["secondary_bucket_id"] != "")) return [3 /*break*/, 14];
                        return [4 /*yield*/, this._services.get('/secondarybucketlist/' + this.model.bucket_id)];
                    case 13:
                        secBuck = _a.sent();
                        if (searchinfo[0]["secondary_bucket_id"].indexOf(",") > -1) {
                            secData_2 = searchinfo[0]["secondary_bucket_id"].split(",");
                            _loop_5 = function (j) {
                                var index_10 = secBuck.findIndex(function (x) { return x.secBucketId == secData_2[j]; });
                                this_5.model.secondary_bucket.push({ "id": secBuck[index_10].secBucketId, "name": secBuck[index_10].secBucketTitle });
                            };
                            this_5 = this;
                            for (j = 0; j < secData_2.length; j++) {
                                _loop_5(j);
                            }
                        }
                        else {
                            index_6 = secBuck.findIndex(function (x) { return x.secBucketId == searchinfo[0]["secondary_bucket_id"]; });
                            this.model.secondary_bucket.push({ "id": secBuck[index_6].secBucketId, "name": secBuck[index_6].secBucketTitle });
                        }
                        _a.label = 14;
                    case 14:
                        // Set personal Data
                        this.model.study_state = new Array();
                        this.model.military_support = searchinfo[0]["military_support"];
                        statelist_2 = searchinfo[0]["study_state"].split(",");
                        for (index = 0; index < statelist_2.length; index++) {
                            sitem = new StudyState();
                            thisState = this.states.find(function (x) { return x.value.toLowerCase() == statelist_2[index].toLowerCase(); });
                            sitem.name = thisState.name;
                            sitem.value = statelist_2[index];
                            this.model.study_state.push(sitem);
                        }
                        // Set Military Data
                        this.model.military_branch = studentinfo["militaryBranch"];
                        if (studentinfo["militaryStatus"] == "Retiree") {
                            this.model.military_status = "Retired";
                        }
                        else {
                            this.model.military_status = studentinfo["militaryStatus"];
                        }
                        _a.label = 15;
                    case 15:
                        this.model.uuid = uuid;
                        this.index = 1;
                        localStorage.setItem("NewUserRegister", 'false');
                        return [2 /*return*/];
                }
            });
        });
    };
    return PworkflowComponent;
}());
export { PworkflowComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/pworkflow.component.ts.pre-build-optimizer.js